import { Injectable, OnDestroy } from '@angular/core';

import { Observable, shareReplay } from 'rxjs';

import { Story } from './models/stories.entities';
import { StoriesDataService } from './stories.data.service';

@Injectable({providedIn: 'root'})
export class StoriesFacadeService implements OnDestroy {

    private getList$: Observable<Array<Story>> | null;

    constructor(private storiesDataService: StoriesDataService) { }

    public getList(): Observable<Array<Story>> {
        if (this.getList$) {
            return this.getList$;
        }

        return this.getList$ = this.storiesDataService.getList().pipe(shareReplay(1));
    }


    public markAsViewed(storyId: number): void {
        this.storiesDataService.markAsViewed(storyId)
            .subscribe();
    }

    public ngOnDestroy(): void {
        this.getList$ = null;
    }

}